"use client";

import React from "react";
import { ArrowDownRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
export default function ContactHero() {
  const shouldReduceMotion = useReducedMotion();
  const handleScrollDown = () => {
    const nextSection = document.getElementById("contact-form-content") || document.querySelector("section:not(#contacthero)");
    if (nextSection) {
      nextSection.scrollIntoView({
        behavior: "smooth"
      });
    } else {
      window.scrollBy({
        top: 600,
        behavior: "smooth"
      });
    }
  };
  return <section id="contacthero" data-nav="dark" className="relative w-full min-h-[520px] md:min-h-[640px] lg:min-h-[720px] flex items-center overflow-hidden bg-foreground text-background">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/contact_hero_representative.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/contact_hero_representative.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/contact_hero_representative.png-wvc-sizes" alt="Equipo de apoyo de la Oficina Nacional de las Asambleas de Dios" className="w-full h-full object-cover object-center" loading="eager" decoding="async" />
        {}
        <div className="absolute inset-0 bg-gradient-to-r from-foreground/80 via-foreground/50 to-foreground/20" />
      </div>

      {}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-20 md:py-28 flex flex-col justify-between min-h-[480px]">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }} className="max-w-3xl space-y-4">
          <span className="inline-block text-xs md:text-sm font-semibold tracking-widest uppercase text-background/80 bg-background/10 backdrop-blur-xs px-3 py-1 rounded-md">
            ASAMBLEAS DE DIOS
          </span>

          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold tracking-tight text-background leading-none uppercase font-default">
            CONTACTE A LA OFICINA NACIONAL DE LAS AD
          </h1>

          <p className="text-lg sm:text-xl md:text-2xl text-background/90 font-medium max-w-2xl pt-2">
            ¿Cómo podemos ayudarte? Estamos a tu disposición para responder tus preguntas y brindarte apoyo.
          </p>
        </motion.div>

        {}
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="self-end pt-8 md:pt-0">
          <Button size="icon" variant="secondary" onClick={handleScrollDown} aria-label="Desplazarse hacia abajo al formulario de contacto" className="size-12 md:size-14 rounded-full bg-background text-foreground hover:bg-background/90 shadow-lg cursor-pointer transition-transform hover:scale-105">
            <ArrowDownRight className="size-6 md:size-7" />
          </Button>
        </motion.div>
      </div>
    </section>;
}